
import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '../../clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import TInput from '@/lib/form/input/Input.vue';
import TubeLabel from '@/lib/form/label/Label.vue';
import TSelect from '@/lib/form/select/Select.vue';
import logger from '@/app/logger';
import Multiselect from 'vue-multiselect';

const PROFILES = {
  user_role: {
    question: 'What best describes your role?',
    options: [
      {
        displayText: 'Product Marketer',
        value: 'pmm',
      },
      {
        displayText: 'Product Manager',
        value: 'pm',
      },
      {
        displayText: 'Customer Success / Training Manager',
        value: 'csm',
      },
      {
        displayText: 'C-suite (CXO)',
        value: 'cxo',
      },
      {
        displayText: 'Support Executive',
        value: 'support',
      },
      {
        displayText: 'Others',
        value: 'others',
      },
    ],
  },

  user_intent: {
    question: 'How do you plan to use Trainn?',
    options: [
      {
        name: 'Create Videos',
        value: 'video_creation',
      },
      {
        name: 'Create Workflow Guides',
        value: 'guides',
      },
      {
        name: 'Create User Manual',
        value: 'user_manual',
      },
      {
        name: 'Set up a Knowledge Base',
        value: 'knowledge_base',
      },
      {
        name: 'Set up an Academy',
        value: 'academy',
      },
      {
        name: 'I want to do it all',
        value: 'all_above',
      },
    ],
  },
  // company_size: {
  //   question: 'What’s the size of your company?',
  //   options: [
  //     {
  //       displayText: 'Only me',
  //       value: '1'
  //     },
  //     {
  //       displayText: '2-10',
  //       value: '2_10'
  //     },
  //     {
  //       displayText: '10-50',
  //       value: '10_50'
  //     },
  //     {
  //       displayText: '50-200',
  //       value: '50_200'
  //     },
  //     {
  //       displayText: '>200',
  //       value: 'gt_200'
  //     }
  //   ]
  // },
  signup_source: {
    question: 'How did you find Trainn?',
    options: [
      {
        displayText: 'Internet Search',
        value: 'search',
      },
      {
        displayText: 'Social Media Platforms',
        value: 'social_media',
      },
      {
        displayText: 'Colleague/Friend',
        value: 'colleague_friend',
      },
      {
        displayText: 'Community Channels',
        value: 'community_channel',
      },
      {
        displayText: 'Customer Educated Podcast',
        value: 'customer_educated_podcast',
      },
      {
        displayText: 'Others',
        value: 'others',
      },
    ],
  },
};

@Component({
  name: 'user-profile-setup',
  props: ['mode', 'context'],
  components: {
    TButton,
    TInput,
    TubeLabel,
    TSelect,
    Multiselect,
  },
})
export default class UserProfileSetup extends Vue {
  private name = '';
  private phone = '';
  private invalid = false;
  private loader = false;
  private context: any;
  private loaded = false;
  private questions: any[] = [];
  private userProfile = {};
  private errors = {};
  mode!: string;

  updateProfile(value, name) {
    delete this.errors[name];
    Vue.set(this.userProfile, name, value);
  }

  updateProfileMultiSelect(value, id) {
    delete this.errors[id];
    Vue.set(this.userProfile, id, value);
  }

  profileQuestion(profileId) {
    return PROFILES[profileId] && PROFILES[profileId].question;
  }

  availableOptions(profileId) {
    return PROFILES[profileId] && PROFILES[profileId].options;
  }

  created() {
    let apiCall = Promise.resolve({ questions: [], name: '' });
    if (this.mode == 'signup') {
      apiCall = apiCall.then(() =>
        apiClient.fetchProfileQuestions({
          authToken: this.context.authToken,
          email: this.context.email,
        })
      );
    } else {
      apiCall = apiCall.then(() => apiClient.getLoginProfileQuestions());
    }

    apiCall
      .then((result) => {
        this.questions = result.questions;
        this.name = result.name;
        this.loaded = true;
      })
      .catch((error) => {
        // Important page so skipping error
        this.questions = [];
        this.loaded = true;
      });
  }

  sanitizedUserProfile() {
    const output = {};
    Object.keys(this.userProfile).forEach((k) => {
      if (Array.isArray(this.userProfile[k])) {
        output[k] = this.userProfile[k].map((v) => v.value);
      } else {
        output[k] = this.userProfile[k];
      }
    });
    return output;
  }

  createUserProfile() {
    this.errors = {};
    if (!this.name) {
      this.invalid = true;
      return;
    }
    this.questions.forEach((q) => {
      if (this.$isEmpty(this.userProfile[q.profile_id])) {
        this.errors[q.profile_id] = true;
      }
    });
    if (!this.$isEmpty(this.errors)) {
      return;
    }
    this.loader = true;
    let apiCall = Promise.resolve();

    if (this.mode == 'signup') {
      apiCall = apiCall.then(() =>
        apiClient.setupUserProfile({
          authToken: this.context.authToken,
          email: this.context.email,
          name: this.name,
          profile: this.sanitizedUserProfile(),
          phone: this.phone,
        })
      );
    } else {
      apiCall = apiCall.then(() =>
        apiClient.updateProfileData(this.name, "", "", this.sanitizedUserProfile(), false)
      );
    }
    apiCall
      .then(() => {
        if (this.context.targetFlow == 'redirect') {
          window.location.href = this.context.redirectUri;
        } else {
          this.$emit('update', {
            flowType: 'set_workspace',
            data: {
              authToken: this.context.authToken,
              googleToken: this.context.googleToken,
            },
          });
        }
      })
      .catch((error) => {
        this.$error(error);
        this.loader = false;
      });
  }
}
